(function () {
    'use strict';

    angular.module("imApp").factory("travExpTypeBusCosService", [function () {
        let service = {};

        return service;
    }]);
})();
